import {
  OnboardingActivity,
  OnboardingActivityStatus,
  OnboardingActivityType,
} from "../utils/interfaces";
import useCommon from "./useCommon";

const useActivityHook = (activity: OnboardingActivity) => {
  const t = useCommon();
  const isActived =
    activity.activation_status === OnboardingActivityStatus.ACTIVATED;
  const isPending =
    activity.activation_status === OnboardingActivityStatus.PENDING;
  const isRejected =
    activity.activation_status === OnboardingActivityStatus.REJECTED;
  const isInProgress =
    activity.activation_status === OnboardingActivityStatus.IN_PROGRESS;
  const name = t(
    `onboarding.${OnboardingActivityType[
      activity.activation_type
    ]?.toLowerCase()}`
  );

  const status =
    activity?.activity_history?.[activity?.activity_history?.length - 1];

  return {
    ...activity,
    isActived,
    isPending,
    isRejected,
    isInProgress,
    name,
    status,
  };
};

export default useActivityHook;
